<script>
    export default {
        props: {
            src: String,
            localCrops: Array,
            index: Number,
            focalpoint: Object
        },
        data() {
            return {
                rnd: 133108242804430000
            }
        },
        computed: {
            focalpointstring() {
                if (!this.focalpoint) return '';
                return `&rxy=${this.focalpoint.Left},${this.focalpoint.Top}`;
            },

        },
        methods: {
            media(crop, index) {
                if (index === this.localCrops.length - 1) return '';
                switch (true) {
                    case (crop.Alias.toLowerCase().includes('mobilesmall')):
                        return `(max-width: 480px)`;
                    case (crop.Alias.toLowerCase().includes('mobile')):
                        return `(max-width: 833px)`;
                    case (crop.Alias.toLowerCase().includes('tablet')):
                        return `(max-width: 1023px)`;
                    case (crop.Alias.toLowerCase().includes('desktop')):
                        return `(max-width: 1215px)`;
                    case (crop.Alias.toLowerCase().includes('widescreen')):
                        return `(max-width: 1439px)`;
                    case (crop.Alias.toLowerCase().includes('fullhd')):
                        return `(min-width: 1439px)`;
                    default:
                        return '';
                }
            }
        }
    };
</script>

<template>
    <picture v-if="src && localCrops && localCrops.length" class="image is-clipped">
        <template v-for="(crop, cropindex) in localCrops" :key="crop.Alias + index">
            <source type="image/webp"
                    :srcset="`
                        ${src}?width=${crop.Width}&amp;height=${crop.Height}&amp;format=webp&amp;quality=90&amp;rnd=${rnd}${focalpointstring} 1x,
                        ${src}?width=${crop.Width * 1.5}&amp;height=${crop.Height * 1.5}&amp;format=webp&amp;quality=90&amp;rnd=${rnd}${focalpointstring} 1.5x
                    `"
                    :sizes="`${crop.Width}px`"
                    :media="media(crop, cropindex)">
            <source :srcset="`
                        ${src}?width=${crop.Width}&amp;height=${crop.Height}&amp;rnd=${rnd}${focalpointstring} 1x,
                        ${src}?width=${crop.Width * 1.5}&amp;height=${crop.Height * 1.5}&amp;rnd=${rnd}${focalpointstring} 1.5x
                    `"
                    :sizes="`${crop.Width}px`"
                    :media="media(crop, cropindex)">
        </template>
        <img :src="src"
             :alt="localCrops[0].Alias"
             :width="localCrops[0].Width"
             :height="localCrops[0].Height"
             loading="lazy"
             onerror="this.onerror=null; this.style.backgroundColor='#cccccc'" />
    </picture>
</template>
